/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Greek (Greece): el-gr
 */

/**
 * Translation file for el-GR locale
 *
 * @file el.js
 * @author Mohamed yasar arabath M
 */

const el = {
  'common.OK': 'OK',
  'common.CONTINUE': 'Συνέχεια',
  'browser.check.DONT_SHOW_AGAIN': 'Don\'t show me this again',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'υποστηριζόμενο λειτουργικό σύστημα και πρόγραμμα περιήγησης Web',
  'browser.check.BROWSER_MESSAGE_TITLE': 'Το πρόγραμμα περιήγησής σου <<name>> είναι παλιό.',
  'browser.check.BROWSER_MESSAGE_DESC': 'Για να έχεις την καλύτερη δυνατή εμπειρία, επίλεξε ένα από τα πιο σύγχρονα προγράμματα περιήγησης:',
  'browser.check.BROWSER_SKIP_NOW': 'Παράλειψη για τώρα',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'Πληροφορίες για τα υποστηριζόμενα προγράμματα περιήγησης',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'Το πρόγραμμα περιήγησής σου <<name>> δεν υποστηρίζεται.',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'Για να έχεις την καλύτερη δυνατή εμπειρία, επίλεξε ένα από τα υποστηριζόμενα προγράμματα περιήγησης.',
  'browser.check.OS_UNSUPPORTED_TITLE': 'Το λειτουργικό σύστημά σου <<name>> δεν υποστηρίζεται.',
  'browser.check.OS_UNSUPPORTED_DESC': 'While the product may work with no issues, please be aware that any problems you encounter might be resolved by trying with a device running a <<link>>',
  'errors.GENERIC_TITLE': 'Σφάλμα διακομιστή',
  'errors.GENERIC_DESC': 'Δυστυχώς το σύστημά μας είναι εκτός λειτουργίας. Προσπάθησε ξανά αργότερα ή επικοινώνησε με το Τμήμα Υποστήριξης.',
  'errors.HTTP_400_TITLE': 'Σφάλμα διακομιστή',
  'errors.HTTP_400_DESC': 'Παρουσιάστηκε κάποιο σφάλμα κατά τη διεκπεραίωση του αιτήματός σου.',
  'errors.HTTP_401_TITLE': 'Έχεις συνδεθεί;',
  'errors.HTTP_401_DESC': 'Δεν μπορέσαμε να λάβουμε τα δεδομένα, επειδή η περίοδος λειτουργίας της σύνδεσής σου ίσως έχει λήξει.',
  'errors.HTTP_403_TITLE': 'Χωρίς εξουσιοδότηση',
  'errors.HTTP_403_DESC': 'You don\'t have access to this resource.',
  'errors.HTTP_888_TITLE': 'Ο διακομιστής άργησε πολύ να αποκριθεί.',
  'errors.HTTP_888_DESC': 'Παρουσιάστηκε κάποιο σφάλμα κατά τη διεκπεραίωση του αιτήματός σου.'
};

export default el;
